import axios from "./axios"; // Import the centralized Axios instance
import prm from "./prm";

const state = {
  permissions: [],
};

const getters = {
  allPermissions: (state) => state.permissions,
};

const actions = {
  async fetchPermissions({ commit }, params = {}) {
    try {
      const response = await axios.get("/permissions", { params: prm(params) });
      commit("setPermissions", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch permissions:", error);
    }
  },
  async createPermission({ commit }, permission) {
    try {
      const response = await axios.post("/permissions", permission);
      commit("addPermission", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create permission:", error);
      throw error;
    }
  },
  async fetchPermissionById(_, id) {
    try {
      const response = await axios.get(`/permissions/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch permission:", error);
      throw error;
    }
  },
  async updatePermission({ commit }, permission) {
    try {
      const response = await axios.put(`/permissions/${permission.id}`, permission);
      commit("updatePermission", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to update permission:", error);
      throw error;
    }
  },
  async deletePermissionById({ commit }, id) {
    try {
      const response = await axios.delete(`/permissions/${id}`);
      commit("removePermission", id);
      return response.data;
    } catch (error) {
      console.error("Failed to delete permission:", error);
      throw error;
    }
  },
};

const mutations = {
  setPermissions(state, permissions) {
    state.permissions = permissions.data;
  },
  addPermission(state, permission) {
    state.permissions.push(permission);
  },
  updatePermission(state, updatedPermission) {
    const index = state.permissions.findIndex(
      (permission) => permission.id === updatedPermission.id
    );
    if (index !== -1) {
      state.permissions.splice(index, 1, updatedPermission);
    }
  },
  removePermission(state, id) {
    state.permissions = state.permissions.filter(
      (permission) => permission.id !== id
    );
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
